export default __webpack_public_path__ + "static/media/404.31db1a21.gif";